import { PurchaseTimeframe as TimeframeEnum } from '@lower-financial/lending-web-api/generated';
import { useMortgageAnalytics } from '@lightspeed/hooks/useMortgageAnalytics/use-mortgage-analytics';
import { CardToggleLayout } from '@lightspeed/components/shared/card-toggle-screen-layout/card-toggle-layout';
import { Testimonial } from '@lightspeed/components/ui/molecules/testimonial';

const PurchaseTimeframeTestimonial = () => (
  <Testimonial
    title={'Highly recommend.'}
    content={'My loan advisor was available 24/7 for me. It didn’t matter what time of the day or night it was, when I had a question and I messaged him, he messaged right back. He went above and bevond what was expected of him. I would definitely work with Lower again in the future and plan on recommending Lower to any/all friends who are in the home buying process.'}
    author={'Jasmine Sinkhada'}
  />
);

export const PurchaseTimeframe = () => {
  const fireAnalyticsEvent = useMortgageAnalytics('purchase_timeframe');

  const cardOptions = [
    {
      label: 'I found the home',
      value: TimeframeEnum.ReadyToMakeOffer,
    },
    {
      label: '0 - 3 months',
      value: TimeframeEnum.Days30To90,
    },
    {
      label: '3 - 6 months',
      value: TimeframeEnum.Months3To6,
    },
    {
      label: 'Over 6 months',
      value: TimeframeEnum.Months6To12,
    },
  ] as const;

  return (
    <CardToggleLayout
      title={'When are you planning to buy?'}
      subtitle={<>Timing is everything, so tell us your plans.&nbsp;⏰</>}
      mortgageApplicationField={'propertyPurchaseTimeframe'}
      fireAnalyticsEvent={fireAnalyticsEvent}
      cardOptions={cardOptions}
      desktopSidebar={<PurchaseTimeframeTestimonial />}
    />
  );
};
